export const ADD_PACKAGE = 'ADD_PACKAGE'

export const addPackage = cruise => ({
  type: ADD_PACKAGE,
  payload: {
    identifier: cruise.identifier,
    cruise
  }
})
